var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"Component"},[_c('Transition',{attrs:{"name":_vm.transitionName,"mode":_vm.transitionMode,"enter-active-class":_vm.transitionEnterActiveClass}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }